export enum Notifications {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}
